module.exports = __webpack_public_path__ + "img/image-not-found.f29d4cfe.png";